import { render, staticRenderFns } from "./PatientMedicationsCard.vue?vue&type=template&id=8c5307f2&scoped=true&"
import script from "./PatientMedicationsCard.vue?vue&type=script&lang=js&"
export * from "./PatientMedicationsCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicationsCard.vue?vue&type=style&index=0&id=8c5307f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5307f2",
  null
  
)

export default component.exports